import {
  createConfig,
  configureChains,
  Chain,
} from 'wagmi'
import { publicProvider } from 'wagmi/providers/public'
import {EthereumClient} from "@web3modal/ethereum";
import { MetaMaskConnector } from 'wagmi/connectors/metaMask'
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect'
import { harmonyOne, arbitrum, bsc, mainnet } from 'wagmi/chains'
import config from '../config'

const supportedChains = [harmonyOne, arbitrum, bsc, mainnet]

const { chains, publicClient, webSocketPublicClient } = configureChains(
  supportedChains,
  [publicProvider()],
)

const walletConnectConnector = new WalletConnectConnector({
  chains: supportedChains,
  options: {
    projectId: config.walletConnectProjectId,
  },
})

export const metamaskConnector = new MetaMaskConnector({ chains })

export const wagmiConfig = createConfig({
  autoConnect: true,
  publicClient,
  webSocketPublicClient,
  connectors: [metamaskConnector, walletConnectConnector],
})

export const ethereumClient = new EthereumClient(wagmiConfig, chains)
